import type { Theme } from "@mui/material/styles";

export const MuiTreeItem = {
  styleOverrides: {
    content: ({ theme }: { theme: Theme }) => ({
      padding: theme.spacing(0.5, 1),
      margin: 0,
      gap: 0,

      "&:hover": {
        backgroundColor: (theme.vars || theme).palette.action.hover,
      },
      "&[data-focused], &[data-selected], &[data-selected][data-focused]": {
        backgroundColor: `var(--tree-view-bg-color, ${(theme.vars || theme).palette.action.selected})`,
        color: "var(--tree-view-color)",
      },
    }),
    groupTransition: {
      marginLeft: 10,
      paddingLeft: 14,
    },
  },
};
